import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import { formatAsMoney, formatDefaultDate } from 'plugin/helper'

class DataPeserta extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataSaldo: {},
    }

    this.divRef = React.createRef()
    this.datagridIuranRef = React.createRef()
    this.datagridKeluargaRef = React.createRef()

    this.dataIuran = []
    this.dataKeluarga = []

    this.columnIurans = [
      {
        dataField: 'tipeIuran',
        caption: 'Tipe Iuran',
      },
      {
        dataField: 'tanggalEfektif',
        caption: 'Tanggal Efektif',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'nominalIuran',
        caption: 'Nominal Iuran',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
    ]

    this.summary = [
      {
        column: 'nominalIuran',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'nominalIuran',
        displayFormat: 'Total : {0}',
      },
    ]

    this.columnKeluarga = [
      {
        dataField: 'nama',
        caption: 'Nama',
      },
      {
        dataField: 'hubunganKeluarga',
        caption: 'Hubungan Keluarga',
      },
      {
        dataField: 'tanggalLahir',
        caption: 'Tgl. Lahir',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'noKtp',
        caption: 'No. KTP',
      },
    ]
  }

  retrieveData = (data) => {
    if (data) {
      let dataIuran = data.iuran
      let dataKeluarga = data.keluarga

      this.dataIuran = dataIuran.map((item, index) => {
        return {
          ...item,
          id: index + 1,
        }
      })
      this.dataKeluarga = dataKeluarga.map((item, index) => {
        return {
          ...item,
          id: index + 1,
        }
      })

      this.forceRefreshIuran()
      this.forceRefreshKeluarga()

      this.setState({
        dataSaldo: data.saldo,
      })
    }
  }

  loadDummyIuran = () => {
    return this.dataIuran
  }

  loadDummyKeluarga = () => {
    return this.dataKeluarga
  }

  forceRefreshIuran = () => {
    this.datagridIuranRef.current.forceRefresh(true)
  }

  forceRefreshKeluarga = () => {
    this.datagridKeluargaRef.current.forceRefresh(true)
  }

  render() {
    let { dataSaldo } = this.state
    return (
      <React.Fragment>
        <Card style={{ height: '284px' }} className="mb-3">
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              overflow: 'hidden',
            }}
          >
            <span style={{ fontWeight: 'bold', fontSize: '20px' }}>Iuran</span>
            <div>
              <DevExpressDataGrid
                ref={this.datagridIuranRef}
                loadAPI={`-`}
                insertAPI="-"
                updateAPI="-"
                deleteAPI="-"
                backendserver={process.env.REACT_APP_BACKEND_CORE}
                useArraySource={true}
                ArraySourceData={this.loadDummyIuran}
                allowAdding={false}
                allowDeleting={false}
                allowUpdating={false}
                height={'212px'}
                exportExcel={false}
                exportFileName={'Pengajuan Peserta Pensiun Ditunda'}
                allowExportSelectedData={false}
                showBorders={false}
                paging={false}
                defaultPageSize={5}
                popupTitle={'Pengajuan Peserta Pensiun Ditunda'}
                popupWidth={700}
                popupHeight={500}
                popupFormLabelLocation="left"
                popupFormMinColWidth={300}
                popupFormColCount={3}
                ColumnChooser={false}
                ColumnFixing={false}
                FilterRow={false}
                ColumnConfiguration={this.columnIurans}
                summaryTotalItem={this.summary}
                store={this.props.store}
              />
            </div>
          </Card.Body>
        </Card>

        <Card style={{ height: '328px' }} className="mb-3">
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              overflow: 'hidden',
            }}
          >
            <span style={{ fontWeight: 'bold', fontSize: '20px' }}>
              Keluarga
            </span>
            <div>
              <DevExpressDataGrid
                ref={this.datagridKeluargaRef}
                loadAPI={`-`}
                insertAPI="-"
                updateAPI="-"
                deleteAPI="-"
                backendserver={process.env.REACT_APP_BACKEND_CORE}
                useArraySource={true}
                ArraySourceData={this.loadDummyKeluarga}
                allowAdding={false}
                allowDeleting={false}
                allowUpdating={false}
                height={'256px'}
                exportExcel={false}
                exportFileName={'Pengajuan Peserta Pensiun Ditunda'}
                allowExportSelectedData={false}
                showBorders={false}
                paging={false}
                defaultPageSize={5}
                popupTitle={'Pengajuan Peserta Pensiun Ditunda'}
                popupWidth={700}
                popupHeight={500}
                popupFormLabelLocation="left"
                popupFormMinColWidth={300}
                popupFormColCount={3}
                ColumnChooser={false}
                ColumnFixing={false}
                FilterRow={false}
                ColumnConfiguration={this.columnKeluarga}
                store={this.props.store}
              />
            </div>
          </Card.Body>
        </Card>

        <Card style={{ height: '304px' }} className="mb-3">
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              overflow: 'hidden',
            }}
          >
            <span style={{ fontWeight: 'bold', fontSize: '20px' }}>Saldo</span>
            <div className="row" style={{ fontSize: '14px' }}>
              <div className="col-md-6">
                <div className="row mb-3 mt-3">
                  <div className="col-md-6">
                    <span>Iuran</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {dataSaldo.iuran ? dataSaldo.iuran : 0} Kali
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Total Iuran</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.totalIuran
                        ? formatAsMoney(dataSaldo.totalIuran)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Saldo Unit Iuran</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.saldoUnitIuran
                        ? formatAsMoney(dataSaldo.saldoUnitIuran)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Nav Rata-Rata</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.navRataRata
                        ? formatAsMoney(dataSaldo.navRataRata)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Frek. Klaim</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {dataSaldo.frekKlaim ? dataSaldo.frekKlaim : 0} Kali
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Nominal Klaim</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp $
                      {dataSaldo.nominalKlaim
                        ? formatAsMoney(dataSaldo.nominalKlaim)
                        : 0}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="row mb-3 mt-3">
                  <div className="col-md-6">
                    <span>Total Unit Klaim</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.totalUnitKlaim
                        ? formatAsMoney(dataSaldo.totalUnitKlaim)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Saldo Unit Terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.saldoUnitTerakhir
                        ? formatAsMoney(dataSaldo.saldoUnitTerakhir)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Tanggal Nav Terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {dataSaldo.tanggalNavTeraakhir
                        ? formatDefaultDate(
                            new Date(dataSaldo.tanggalNavTeraakhir)
                          )
                        : '-'}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Nilai Nav/Unit Terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.nilaiNavTerakhir
                        ? formatAsMoney(dataSaldo.nilaiNavTerakhir)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Pengembangan</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {dataSaldo.pengembangan
                        ? formatAsMoney(dataSaldo.pengembangan)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Iuran + Pengembangan</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp $
                      {dataSaldo.iuranPengembangan
                        ? formatAsMoney(dataSaldo.iuranPengembangan)
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </React.Fragment>
    )
  }
}

export default DataPeserta
